
import { defineComponent } from 'vue';
import Modal from '@/components/info/Modal.vue';

export default defineComponent({
  name: 'Explain',
  props: {
    title: String,
    extraClasses: {
      type: String,
      default: '',
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showing: false,
    };
  },
});
